import React, { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where, updateDoc, doc, getDocs, getDoc, orderBy } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { db } from '../../../firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEdit, faVolumeUp, faVolumeMute } from '@fortawesome/free-solid-svg-icons';
import CommandeDetailsModal from './CommandeDetailsModal';
import EditCommandeModal from './EditCommandeModal';
import ReactPaginate from 'react-paginate';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';


const Commandes = () => {
    const [commandes, setCommandes] = useState([]);
    const [plats, setPlats] = useState([]);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedCommande, setSelectedCommande] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
 
    const [isUpdating, setIsUpdating] = useState(false);

    const [showErrorModal, setShowErrorModal] = useState(false);
const [errorMessage, setErrorMessage] = useState('');

    // États pour les filtres
    const [dateService, setDateService] = useState('');
    const [statutPaiement, setStatutPaiement] = useState('');
    const [statutCommande, setStatutCommande] = useState('');
      const [searchNomPrenom, setSearchNomPrenom] = useState('');


    // États pour la pagination
    const [currentPage, setCurrentPage] = useState(0);
    const commandesPerPage = 10;

useEffect(() => {
  const commandesQuery = collection(db, 'commande');

  let q = query(commandesQuery);

  if (statutPaiement) {
    q = query(q, where('statut_paiement', '==', statutPaiement));
  }

  if (statutCommande) {
    q = query(q, where('statut_commande', '==', statutCommande));
  }

  q = query(q, orderBy('id', 'desc'));

  const unsubscribe = onSnapshot(
    q,
    (snapshot) => {
      setLoading(true);
      setError(null);

      let newCommandes = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      newCommandes.sort((a, b) => parseInt(b.id) - parseInt(a.id));

      setCommandes(newCommandes);
      setLoading(false);
    },
    (error) => {
      console.error('Erreur de récupération des commandes : ', error);
      setError('Impossible de charger les commandes. Veuillez réessayer.');
      setLoading(false);
    }
  );

  return () => unsubscribe();
}, [statutPaiement, statutCommande]);

    useEffect(() => {
        const fetchPlats = async () => {
            try {
                const platsCollection = collection(db, 'food-items');
                const platsSnapshot = await getDocs(platsCollection);
                const platsList = platsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setPlats(platsList);
            } catch (error) {
                console.error("Erreur de chargement des plats : ", error);
                setError("Impossible de charger les plats. Veuillez réessayer.");
            }
        };

        fetchPlats();
    }, []);

      const resetFilters = () => {
    setSearchNomPrenom('');
    setDateService('');
    setStatutPaiement('');
    setStatutCommande('');
    setCurrentPage(0);
};
const formatDateForCompare = (value) => {
    if (!value) return '';

    const datePart = String(value).split(' ')[0]; // 27/03/2026
    const [day, month, year] = datePart.split('/');

    if (!day || !month || !year) return '';

    return `${year}-${month}-${day}`; // 2026-03-27
};


const filteredCommandes = commandes.filter((commande) => {
    const recherche = searchNomPrenom.trim().toLowerCase();

    const fullName = `${commande.nom || ''} ${commande.prenom || ''}`.toLowerCase();
    const reverseFullName = `${commande.prenom || ''} ${commande.nom || ''}`.toLowerCase();

    const matchNomPrenom =
        !recherche ||
        fullName.includes(recherche) ||
        reverseFullName.includes(recherche) ||
        (commande.nom || '').toLowerCase().includes(recherche) ||
        (commande.prenom || '').toLowerCase().includes(recherche);

    const commandeDate = formatDateForCompare(commande.date_service);
    const matchDate = !dateService || commandeDate === dateService;

    return matchNomPrenom && matchDate;
});

const getStatutPaiementFR = (status) => {
  switch (status) {
    case 'requires_payment_method':
      return 'Paiement échoué';
    case 'requires_confirmation':
      return 'À confirmer';
    case 'requires_action':
      return 'Action requise';
    case 'processing':
      return 'En cours de traitement';
    case 'requires_capture':
      return 'Non capturé';
    case 'succeeded':
      return 'Réussi';
    case 'canceled':
      return 'Annulé';
    default:
      return status || 'Inconnu';
  }
};



    const handleShowDetails = (commande) => {
        setSelectedCommande(commande);
        setShowDetailsModal(true);
    };

    const handleShowEdit = (commande) => {
        setSelectedCommande(commande);
        setShowEditModal(true);
    };

    const handleClose = () => {
        setShowDetailsModal(false);
        setShowEditModal(false);
        setSelectedCommande(null);
    };

    const handleSave = async (updatedCommande) => {
        updatedCommande.plats = updatedCommande.plats.map(plat => ({
            id: plat.id,
            taille: plat.taille,
            total: plat.total,
            nom: plat.nom,
            prix: plat.prix,
            quantite: plat.quantite,
            instructions: plat.instructions,
            addons: plat.selectedAddons 
        }));

        
        try {
            const commandeRef = doc(db, 'commande', updatedCommande.id);
            await updateDoc(commandeRef, updatedCommande);

            setCommandes(prevCommandes =>
                prevCommandes.map(cmd =>
                    cmd.id === updatedCommande.id ? updatedCommande : cmd
                )
            );

            handleClose();
        } catch (error) {
            console.error("Erreur de mise à jour de la commande : ", error);
            setError("Impossible de mettre à jour la commande. Veuillez réessayer.");
        }

        
    };

    const showPopupError = (message) => {
  setErrorMessage(message);
  setShowErrorModal(true);
};

 const updateCommandeStatus = async (commande, commandeId, newStatus, paymentIntentId) => {
   
  setIsUpdating(true);

  try {
    const commandeRef = doc(db, 'commande', commandeId);

if (newStatus === 'Accepté') {
  if (!paymentIntentId) {
    throw new Error("paymentIntentId manquant pour capturer le paiement.");
  }

  if (commande.statut_paiement !== 'requires_capture') {
    throw new Error(
      `Paiement non capturable. Statut actuel : ${commande.statut_paiement}`
    );
  }

  const captureResult = await handleCapturePayment(paymentIntentId);

      await updateDoc(commandeRef, {
        statut_commande: 'Accepté',
        statut_paiement: captureResult.status, // normalement succeeded
      });

      setCommandes(prevCommandes =>
        prevCommandes.map(cmd =>
          cmd.id === commandeId
            ? { ...cmd, statut_commande: 'Accepté', statut_paiement: captureResult.status }
            : cmd
        )
      );

      const emailContent = await getEmailContent('confirmationCommande');

      const emailResponse = await fetch('https://api-7zyk3qftka-uc.a.run.app/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: commande.email,
          nom: commande.nom,
          prenom: commande.prenom,
          plats: commande.plats,
          total: commande.montant,
          date_service: commande.date_service,
          objet: emailContent.objet,
          emailContent1: emailContent.texte,
          emailContent2: emailContent.texte2
        }),
      });

      if (!emailResponse.ok) {
        console.error("Erreur lors de l'envoi de l'email de confirmation");
      }
    }

if (newStatus === 'Refusé') {
  if (!paymentIntentId) {
    console.error("paymentIntentId manquant pour annuler le paiement.");
    setIsUpdating(false);
    return;
  }

  if (commande.statut_paiement !== 'requires_capture') {
    console.error(
      `Annulation impossible : statut Stripe = ${commande.statut_paiement}`
    );
    setIsUpdating(false);
    return;
  }

  let cancelResult = null;

  try {
    cancelResult = await handleCancelPayment(paymentIntentId);
  } catch (error) {
    // ✅ ON NE FAIT RIEN côté UI
    console.error("CancelPayment failed (IGNORÉ):", error);

    // ❗ on stop ici → pas de modification Firestore
    setIsUpdating(false);
    return;
  }

  // ✅ uniquement si Stripe OK
  await updateDoc(commandeRef, {
    statut_commande: 'Refusé',
    statut_paiement: cancelResult.status,
  });

  setCommandes(prevCommandes =>
    prevCommandes.map(cmd =>
      cmd.id === commandeId
        ? { ...cmd, statut_commande: 'Refusé', statut_paiement: cancelResult.status }
        : cmd
    )
  );

  const emailAnn = await getEmailContent('annulationCommande');

  await fetch('https://api-7zyk3qftka-uc.a.run.app/api/email-annulation', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email: commande.email,
      nom: commande.nom,
      prenom: commande.prenom,
      objet: emailAnn.objet,
      emailContent: emailAnn.texte
    }),
  });
}

    setIsUpdating(false);
  } catch (error) {
    console.error("Erreur lors de la mise à jour du statut de la commande :", error);
    showPopupError(error.message || "Impossible de mettre à jour le statut de la commande.");
    setIsUpdating(false);
  }
};


    const getEmailContent = async (id) => {
        try {
            const emailDoc = await getDoc(doc(db, 'email', id));
            if (emailDoc.exists()) {
                return emailDoc.data();
            } else {
                console.error('Document email non trouvé');
                return '';
            }
        } catch (error) {
            console.error('Erreur lors de la récupération de l\'email:', error);
            return '';
        }
    };

        const handleCapturePayment = async (paymentIntentId) => {
  try {
    const response = await fetch('https://api-7zyk3qftka-uc.a.run.app/api/capture-payment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ paymentIntentId }),
    });

    const data = await response.json();

    if (!data.success) {
      throw new Error(data.error || 'Erreur lors de la capture du paiement');
    }

    return data;
  } catch (error) {
    console.error('Erreur capture paiement:', error);
    throw error;
  }
};

const handleCancelPayment = async (paymentIntentId) => {
  try {
    const response = await fetch('https://api-7zyk3qftka-uc.a.run.app/api/cancel-payment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ paymentIntentId }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.error || "Erreur lors de l'annulation du paiement");
    }

    return data;
  } catch (error) {
    console.error("Erreur annulation paiement:", error);
    throw error;
  }
};


    const handleRefund = async (paymentIntentId) => {
        const emailAnn = await getEmailContent('annulationCommande');
        try {
            const response = await fetch('https://api-7zyk3qftka-uc.a.run.app/api/refund', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ paymentIntentId }),
            });

            const data = await response.json();

            if (data.success) {
                console.log('Remboursement réussi:', data.refund);
            } else {
                console.error('Erreur lors du remboursement:', data.error);
            }
        } catch (error) {
            console.error('Erreur de connexion au serveur:', error);
        }

        const emailResponse = await fetch('https://api-7zyk3qftka-uc.a.run.app/api/email-annulation', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: selectedCommande.email,
                nom: selectedCommande.nom,
                prenom: selectedCommande.prenom,
                objet:emailAnn.objet,
                emailContent:emailAnn.texte
            }),
        });
        
    };


    const indexOfLastCommande = (currentPage + 1) * commandesPerPage;
const indexOfFirstCommande = indexOfLastCommande - commandesPerPage;

const currentCommandes = filteredCommandes.slice(indexOfFirstCommande, indexOfLastCommande);
const pageCount = Math.ceil(filteredCommandes.length / commandesPerPage);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    if (loading) {
        return <div>Chargement...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div id="content-wrapper" className="d-flex flex-column ">
            <div id="content">
                <div className="container-fluid ">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h1 className="h3 text-gray-800">Commandes</h1>
                        
                    </div>
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 d-flex align-items-center gap-2 flex-wrap">
                            <h6 className="m-0 font-weight-bold title-2 mr-4">Toutes les commandes</h6>

                            <input
                                type="text"
                                className="form-control w-auto mr-2"
                                placeholder="Rechercher nom / prénom"
                                value={searchNomPrenom}
                                onChange={(e) => {
                                    setSearchNomPrenom(e.target.value);
                                    setCurrentPage(0);
                                }}
                            />

                            <input
                                type="date"
                                className="form-control w-auto mr-2"
                                value={dateService}
                                onChange={(e) => {
                                    setDateService(e.target.value);
                                    setCurrentPage(0);
                                }}
                            />
                            <button
                                className="btn btn-secondary"
                                onClick={resetFilters}
                            >
                                Réinitialiser
                            </button>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered" width="100%">
                                    <thead>
                                        <tr>
                                            <th>Commande</th>
                                            <th>Date de commande</th>
                                            <th>Date de récupération</th>
                                            <th>Nom</th>
                                            <th>Code promo</th>
                                            <th>Statut de paiement</th>
                                            <th>Statut de la commande</th>
                                            <th>Montant</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentCommandes.map((commande) => (
                                            <tr key={commande.id}>
                                                <td>#{commande.id}</td>
                                                <td>{commande.date_commande}</td>
                                                <td>{commande.date_service}</td>
                                                <td>{commande.nom} {commande.prenom}</td>
                                                <td>{commande.code_promo_utilise || '-'}</td>
                                                <td>{getStatutPaiementFR(commande.statut_paiement)}</td>
                                                <td>{commande.statut_commande}</td>
                                                <td>{commande.montant}€</td>
                                                <td className="wth-100">
    <div className="d-flex align-items-center flex-wrap gap-2">
        <Link
            className="btn btn-info btn-circle btn-sm"
            to="#"
            onClick={() => handleShowDetails(commande)}
            aria-label={`View details for commande ${commande.id}`}
        >
            <FontAwesomeIcon icon={faEye} />
        </Link>

 {/* <Link className="btn btn-primary btn-circle btn-sm ml-2" to="#" onClick={() => handleShowEdit(commande)} aria-label={`Edit commande ${commande.id}`}>
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </Link> */}

        {commande.statut_commande !== 'Accepté' && commande.statut_commande !== 'Refusé' && (
            <>
                <Button
                    disabled={isUpdating}
                    variant="success"
                      style={{ minWidth: '110px', whiteSpace: 'nowrap' }}
                    size="sm"
                    className="ml-2"
                    onClick={() =>
                        updateCommandeStatus(
                            commande,
                            commande.id,
                            'Accepté',
                            commande.paymentIntentId
                        )
                    }
                >
                    {isUpdating && selectedCommande?.id === commande.id
                        ? <span>Accepter <span className="spinner-border spinner-border-sm"></span></span>
                        : 'Accepter'}
                </Button>

                <Button
                    disabled={isUpdating}
                    variant="danger"
                    size="sm"
                    className="ml-2"
                    onClick={() =>
                        updateCommandeStatus(
                            commande,
                            commande.id,
                            'Refusé',
                            commande.paymentIntentId
                        )
                    }
                >
                    {isUpdating && selectedCommande?.id === commande.id
                        ? <span>Refuser <span className="spinner-border spinner-border-sm"></span></span>
                        : 'Refuser'}
                </Button>
            </>
        )}
    </div>
</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <ReactPaginate
                                    previousLabel={'Précédent'}
                                    nextLabel={'Suivant'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {selectedCommande && showDetailsModal && (
                <CommandeDetailsModal
                    show={showDetailsModal}
                    handleClose={handleClose}
                    commande={selectedCommande}
                />
            )}

            {selectedCommande && showEditModal && (
                <EditCommandeModal
                    show={showEditModal}
                    handleClose={handleClose}
                    handleSave={handleSave}
                    commande={selectedCommande}
                    plats={plats}
                />
            )}

            <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Erreur</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <p>{errorMessage}</p>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowErrorModal(false)}>
      Fermer
    </Button>
  </Modal.Footer>
</Modal>
        </div>
    );
};

export default Commandes;
